export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20football%20field%20with%20warm%20golden%20hour%20lighting%2C%20artistic%20wide%20angle%20view%20of%20green%20pitch%20with%20subtle%20lens%20flare%2C%20atmospheric%20sports%20photography%20with%20rich%20textures%20and%20deep%20greens%2C%20professional%20stadium%20aesthetic%20with%20soft%2C%20warm%20tones&width=1800&height=600&seq=kaiyun-cta-bg&orientation=landscape"
          alt="加入开云足球"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开启极致足球之旅了吗？
        </h2>
        <p className="text-background-300 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          立即加入开云足球，与来自全球的数百万足球爱好者一起，体验最纯粹的足球激情与乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/category/events"
            className="px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
          >
            立即注册
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="/about"
            className="px-8 py-3.5 rounded-full border-2 border-background-300/30 text-background-200 font-semibold text-sm md:text-base hover:bg-background-50/10 hover:border-background-200/50 transition-all duration-200 whitespace-nowrap"
          >
            联系客服
          </a>
        </div>
      </div>
    </section>
  );
}